import classNames from "classnames"

import SolutionDisplay from "../../components/SolutionDisplay"
import { useResolvedSolution } from "../../useResolvedSolution"
import type { SolutionItem } from "../types"

import Typography from "@components/elements/V2/Typography"
import { storyblokHorizontalGutterClasses } from "@constants/spacing"
import { Color } from "@constants/V2/color"
import React from "react"

interface Props {
  solution: SolutionItem[]
  description: string
  breadcrumbs: string[]
  showLinks?: boolean
}

const Results = ({
  solution,
  description,
  breadcrumbs,
  showLinks = true,
}: Props) => {
  const resolvedSolution = useResolvedSolution(solution)
  const hasResults = resolvedSolution.length > 0

  return (
    <div
      className={classNames(
        "pb-0 pt-20 sm:pb-[80px] sm:pt-[50px] lg:pt-[30px]",
        storyblokHorizontalGutterClasses
      )}
    >
      <div className="my-16 flex items-center justify-start pt-[15px] sm:pt-0">
        <Typography
          text="Quiz results"
          font="grotesk"
          weight="medium"
          size="body-md"
          color={Color.Black}
        />
        <Typography
          text={`(${resolvedSolution.length} results found)`}
          font="grotesk"
          weight="medium"
          size="subscript-md-fixed"
          color={Color.Black}
          className="ml-4 opacity-50"
        />
      </div>

      <Typography
        text={
          hasResults
            ? "We've found products that best suit your business!"
            : "Oops, there are no offers currently available..."
        }
        font="grotesk"
        weight="medium"
        size="lead-lg"
        color={Color.Black}
        className="mb-10"
      />

      <Typography
        text={[...breadcrumbs].join(" + ")}
        font="grotesk"
        weight="medium"
        size="body-sm"
        color={Color.Black}
        className="mb-10 block md:hidden"
      />

      {hasResults && (
        <>
          <Typography
            text={description}
            font="grotesk"
            weight="book"
            size="body-md"
            color={Color.Charcoal}
            className="opacity-60"
          />

          <SolutionDisplay solution={solution} showLinks={showLinks} />
        </>
      )}
    </div>
  )
}

export default Results
